import { createSlice } from '@reduxjs/toolkit';
import { getNotificationList } from '../thunks/notificationThunk';

const initialState = {
  list: [],
  total: 0,
  loading: false,
  error: null,
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setData(state, action) {
      state.list = action.payload.data;
      state.total = action.payload.total;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getNotificationList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getNotificationList.fulfilled, (state, action) => {
        state.list = action.payload.data;
        state.total = action.payload.total;
        state.loading = false;
      })
      .addCase(getNotificationList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setData } = notificationSlice.actions;
export default notificationSlice.reducer;